import { createI18n } from "vue-i18n";
import { languages } from "./locales";

export default createI18n({
  legacy: false,
  locale: "pt-BR",
  fallbackLocale: "pt-BR",
  messages: languages,
});
